import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography, Radio, FormControlLabel } from "@material-ui/core";
import { agendaSeleccionarTurno } from '../../../actions/turnos/agenda';
import { OBRAS_SOCIALES } from '../../../utils/constants';

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const PrimerTurno = (props) => {
    const dispatch = useDispatch();
    const { seleccionado } = useSelector((state) => state.agenda);

    const handleChangeTipoTurno = (idTipoTurno) => {
        const newItem = {...seleccionado, idTipoTurno: idTipoTurno}
        dispatch( agendaSeleccionarTurno(newItem) )
    }

    const { idObraSocial } = props;
    
    console.log(idObraSocial);

    return (
        <>
            <Grid container justify="center" spacing={1} style={{marginTop: 15}}>
                <Grid item xs={4}>
                    <Typography variant="h6" /* component="p" */ class="typografy">
                        <strong>Fecha: </strong>{new Date(seleccionado.fecha).toLocaleString("es", optionsfecha)}
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant="h6" /* component="p" */ class="typografy">
                        <strong>Hora: </strong>{seleccionado.hora}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container justify="center" spacing={1} >
                <Grid item xs={8}>
                    <Typography variant="h6" /* component="p" */ class="typografy">
                        <strong>Profesional: </strong>{seleccionado.efectorRed.nombreEfector}
                    </Typography>
                </Grid>
            </Grid>
            {seleccionado.idTipoTurno === 3
                ?
                    <Grid container justify="center" spacing={1} style={{marginBottom: 15}}>
                        <Grid item xs={8}>
                            <Typography variant="h6" class="typografy" style={{marginTop: 2}}>
                                <strong>Modalidad: </strong>
                                <FormControlLabel
                                    style={{marginLeft: 15}}
                                    value="top"
                                    control={<Radio color="primary" /* checked={seleccionado?.idTipoTurno === 1} */ onChange={() => handleChangeTipoTurno(1)} />}
                                    label="Presencial"
                                />
                                {<FormControlLabel
                                    value="top"
                                    control={<Radio color="primary" /* checked={seleccionado?.idTipoTurno === 2} */ onChange={() => handleChangeTipoTurno(2)} />}
                                    label="Virtual"
                                    disabled={idObraSocial !== OBRAS_SOCIALES.OSPEDYC}
                                />}
                            </Typography>
                        </Grid>
                    </Grid>
                :
                    <Grid container justify="center" spacing={1} style={{marginBottom: 15}}>
                        <Grid item xs={8}>
                            <Typography variant="h6" class="typografy">
                                <strong>Modalidad: </strong>{seleccionado.idTipoTurno === 1 ? 'Presencial' : 'Virtual'}
                            </Typography>
                        </Grid>
                    </Grid>
            }
        </>
    );

};
